import { inject, Service } from "@angular/core";

import { MainResponseModel, StrategyDashboardManagementRule } from "../models";
import { MainService } from ".";

@Service()
export class StrategyDashboardManagementApiService {
  private _mainService = inject(MainService);

  public getAll() {
    return this._mainService.sendRequest<MainResponseModel<StrategyDashboardManagementRule[]>>({
      url: "dashboardVisibility/getAll/?limit=99999&offset=0",
      method: "GET",
    });
  }

  public update(rules: StrategyDashboardManagementRule[]) {
    return this._mainService.sendRequest<MainResponseModel>({
      url: "dashboardVisibility/update",
      method: "POST",
      data: rules,
    });
  }
}
